import { ChannelInterface } from "../interfaces/Channel.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_CHANNEL: ChannelInterface = {
	id: "",
	active: true,
	index: "1",
	name: "",
	server_id: "",
	type: "ADAPTER",
	baud_rate: 1,
	channel_id: "",
	heartbeat_frequency: 1,
	reporting_socket_address: "",
	socket_address: "",
	vendor_socket_address: "",
	message_type: "LN2-PRTCL",
	connection_type: "TCP",
};
